package com.shadowings.gero.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.shadowings.gero.domain.repository.AuthRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

import com.shadowings.gero.domain.repository.AnalyticsRepository

class AuthViewModel(
    private val authRepository: AuthRepository,
    private val analyticsRepository: AnalyticsRepository,
) : ViewModel() {

    private val _email = MutableStateFlow("")
    val email = _email.asStateFlow()

    private val _password = MutableStateFlow("")
    val password = _password.asStateFlow()

    private val _confirmPassword = MutableStateFlow("")
    val confirmPassword = _confirmPassword.asStateFlow()

    private val _isRegistering = MutableStateFlow(false)
    val isRegistering = _isRegistering.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading = _isLoading.asStateFlow()

    private val _error = MutableStateFlow<String?>(null)
    val error = _error.asStateFlow()

    private val _success = MutableStateFlow(false)
    val success = _success.asStateFlow()

    private val _termsAccepted = MutableStateFlow(false)
    val termsAccepted = _termsAccepted.asStateFlow()

    fun setEmail(value: String) { _email.value = value }
    fun setPassword(value: String) { _password.value = value }
    fun setConfirmPassword(value: String) { _confirmPassword.value = value }
    fun setTermsAccepted(value: Boolean) { _termsAccepted.value = value }
    fun toggleMode() {
        _isRegistering.value = !_isRegistering.value
        _error.value = null
    }

    fun submit() {
        val mail = _email.value.trim()
        val pwd = _password.value
        val cpwd = _confirmPassword.value

        if (mail.isEmpty() || pwd.isEmpty()) {
            _error.value = "Compila tutti i campi"
            return
        }

        if (_isRegistering.value && pwd != cpwd) {
            _error.value = "Le password non coincidono"
            return
        }

        if (_isRegistering.value && !_termsAccepted.value) {
            _error.value = "Devi accettare i termini per registrarti"
            return
        }

        _isLoading.value = true
        _error.value = null

        viewModelScope.launch {
            val result = if (_isRegistering.value) {
                authRepository.signUpWithEmail(mail, pwd)
            } else {
                authRepository.signInWithEmail(mail, pwd)
            }

            result.onSuccess {
                // La sync/merge iniziale al login viene gestita dal flusso auto-sync centrale.

                if (_isRegistering.value) {
                    analyticsRepository.logSignUp()
                } else {
                    analyticsRepository.logLogin()
                }
                _isLoading.value = false
                _success.value = true
            }.onFailure { exception ->
                _isLoading.value = false
                _error.value = exception.message ?: "Si è verificato un errore"
            }
        }
    }

    fun signInWithGoogle() {
        if (_isRegistering.value && !_termsAccepted.value) {
            _error.value = "Devi accettare i termini per registrarti"
            return
        }
        _isLoading.value = true
        _error.value = null
        viewModelScope.launch {
            authRepository.signInWithGoogle()
                .onSuccess {
                    analyticsRepository.logLogin()
                    _isLoading.value = false
                    _success.value = true
                }
                .onFailure { exception ->
                    _isLoading.value = false
                    _error.value = exception.message ?: "Si è verificato un errore"
                }
        }
    }

    fun resetSuccess() {
        _success.value = false
    }
}
